<div
  echarts
  [theme]="theme"
  [options]="chartOptions"
  [style.width]="chartWidthStyle"
  [style.height.px]="chartHeight"
></div>
